import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NursingStationComponent} from './nursingstation.component';

const routes: Routes = [
    {path: 'login', loadChildren: 'app/login/login.module#LoginModule'},
    {
        path: 'nursingstation', component: NursingStationComponent,
        children: [
            {path: 'documents', loadChildren: 'app/nursingstation/documents/documents.module#DocumentsModule'},
            {path: 'admissionlist', loadChildren: 'app/configuration/trn-admission/trn-admission.module#TrnAdmissionModule'},
            /* { path: 'admissionlist', loadChildren: 'app/nursingstation/admissionlist/admissionlist.module#AdmissionListModule' },*/
            {path: 'nursingconsole', loadChildren: 'app/nursingstation/nursingconsole/nursingconsole.module#NursingConsoleModule'},
            {path: 'staffdirectory', loadChildren: 'app/nursingstation/staffdirectory/staffdirectory.module#StaffdirectoryModule'}
        ]
    }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/nursingstation/nursingstation.routing.ts